import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {guideTranscriptType} from "./__graphql-types__/index.ts";

export const GUIDE_TRANSCRIPT_QUERY: GqlOperation<
    guideTranscriptType["response"],
    guideTranscriptType["variables"]
> = gqlOp(gql`
    query guideTranscript($transcriptId: String!) {
        aiGuideThread(threadId: $transcriptId) {
            id
            summary
            lastUpdatedAt
            flagged
            kaid
            title
            insights {
                interests
                topics
                offTopic
                safety
                languages
                title
                summary
                math
            }
            interactions {
                id
                answer
                question
                userInputImage
                url
                isClassroom
                createdAt
                flagged
                flaggedCategories
                responseWasStoppedByUser
                traceID
                pageType
                pageTitle
                imageMetadata {
                    id
                    llmSummary
                }
            }
            blooketQuestionSet {
                id
                title
                description
                questions {
                    text
                    answers {
                        text
                        isCorrect
                    }
                }
            }
            coeditingDocument {
                id
                snapshots {
                    id
                    createdAt
                    text {
                        prefix
                        selection
                        suffix
                    }
                }
            }
        }
    }
`);
